export const APP_NAME = 'Campaign Dashboard'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'